export const FreemiumSignUpENUSTranslations = {
  freemiumSignUpPageHeadTitle: 'Cadastro Freemium | 4intellingence',
  freemiumSignUpPageHeadDescription:
    'Crie sua conta para começar a usar nossa plataforma freemium',
  freemiumSignUpPageTitle:
    'Crie sua conta para começar a usar nossa plataforma',
  freemiumSignUpPageDescription:
    'Preencha os campos abaixo para iniciar seu cadastro de forma gratuita.',
  freemiumSignUpPageCreateAccount: 'Criar conta',
  freemiumSignUpPageRequiredField:
    'Por favor, preencha todos os campos obrigatórios antes de confirmar.',
  freemiumSignUpPageInvalidEmail: 'O e-mail deve ser formatado corretamente.',
  freemiumSignUpPageIsNotCompanyEmail: 'Use um e-mail corporativo.',
  freemiumSignUpPageDifferenteEmail:
    'E-mails não coincidem. Por favor, verifique.',
  freemiumSignUpPageEmailAlreadyExists:
    'Esse e-mail já está vinculado a uma conta. <a href="https://app.4intelligence.ai/" target="_blank" rel="noreferrer">Faça login</a>.',
  freemiumSignUpPageFirstCarouselPageButton:
    'Botão da primeira página do carrossel',
  freemiumSignUpPageSecondCarouselPageButton:
    'Botão da segunda página do carrossel',
  freemiumSignUpPageThirdCarouselPageButton:
    'Botão da terceira página do carrossel',
  nameErrorNoSpecialCharacters:
    'Caracteres especiais e números não são permitidos.',
  charactersLengthError: 'Não deve conter mais do que 100 caracteres.',
  invalidPhoneNumber: 'Insira um número de telefone válido.',
};
